module.exports = __webpack_public_path__ + "assets/img/de7cb4124aeaabc9bb3a971475bf5837.png";